import React from 'react';
import { Section } from './ui/Section';
export function DecisionGuideSection() {
  const rows = [{
    condition: 'Me hincho sobre todo por la tarde y trabajo sentada',
    solution: 'Empieza por: BONUS Ruta Oficina + sigue el Plan 14 días como base'
  }, {
    condition: 'No tengo tiempo y abandono por falta de preparación',
    solution: 'Empieza por: BONUS Ruta Cero Tiempo (Batch 10 min) + Plan 14 días'
  }, {
    condition: 'Mi problema es el picoteo y el dulce a las 18:00',
    solution: 'Empieza por: BONUS Ruta Antojos 18:00 + Plan 14 días'
  }, {
    condition: 'Quiero lo más simple y seguro',
    solution: 'Empieza por: Plan 14 días (elige un horario fijo) y añade 1 bonus si lo necesitas'
  }];
  return <Section background="cream" data-id="element-1">
      <div className="text-center mb-8 md:mb-12" data-id="element-2">
        <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#2D2A26] mb-3 md:mb-4" data-id="element-3">
          Qué usar según tu caso (guía rápida)
        </h2>
      </div>

      <div className="overflow-hidden rounded-xl border border-[#E8E2DA] shadow-sm bg-white" data-id="element-4">
        <div className="grid grid-cols-1 md:grid-cols-2 bg-[#5B7C5B] text-white font-serif font-bold text-base md:text-lg" data-id="element-5">
          <div className="p-4 md:p-6 border-b md:border-b-0 md:border-r border-[#8BA88B]" data-id="element-6">
            Tu situación
          </div>
          <div className="p-4 md:p-6" data-id="element-7">Recomendación</div>
        </div>

        {rows.map((row, index) => <div key={index} className={`grid grid-cols-1 md:grid-cols-2 ${index !== rows.length - 1 ? 'border-b border-[#E8E2DA]' : ''}`} data-id="element-8">
            <div className="p-4 md:p-6 bg-[#FAF7F2] md:border-r border-[#E8E2DA] font-medium text-[#2D2A26] text-sm md:text-base" data-id="element-9">
              "{row.condition}"
            </div>
            <div className="p-4 md:p-6 bg-white text-[#5B7C5B] font-medium text-sm md:text-base" data-id="element-10">
              {row.solution}
            </div>
          </div>)}
      </div>
    </Section>;
}